import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from 'vue'
    import { useId, useRouter } from '@common/composables'
    import { useAdminConnectorDetailsPage } from '@Integrations/Connectors/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConnectorDetailsPage',
  setup(__props) {

    const router = useRouter()
    const id = useId()

    const {
        useCurrentUserQuery,
        useConnectorDetailsQuery,
        useDeleteConnectorCommand,
        usePermanentDeleteConnectorCommand,
    } = useAdminConnectorDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorDetailsQueryV1, runConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const isDeleted = computed(() => modelConnectorDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteConnectorCommandV1, succeedDeleteConnectorCommandV1 } = useDeleteConnectorCommand(id, tid, userId)
    const { invokePermanentDeleteConnectorCommandV1, succeedPermanentDeleteConnectorCommandV1 } = usePermanentDeleteConnectorCommand(id)

    function handleClearConnectorItemsCommandV1() {
        if (confirm('Do you want to clear all connector items permenently?')) {
            invokeClearConnectorItemsCommandV1()
        }
    }

    function handleDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to delete connector ${name.value}?`)) invokeDeleteConnectorCommandV1()
    }

    function handlePermanentDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete connector ${name.value}?`)) invokePermanentDeleteConnectorCommandV1()
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
    })

    watch(name, () => document.title = name.value)

    watch([succeedDeleteConnectorCommandV1], () => runConnectorDetailsQueryV1())

    watch(succeedPermanentDeleteConnectorCommandV1, (val) => val ? router.push(`/admin/integrations/connectors/manage/${tid.value}`) : null)

return { __sfc: true,router, id, useCurrentUserQuery, useConnectorDetailsQuery, useDeleteConnectorCommand, usePermanentDeleteConnectorCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelConnectorDetailsQueryV1, runConnectorDetailsQueryV1, tid, name, isDeleted, invokeDeleteConnectorCommandV1, succeedDeleteConnectorCommandV1, invokePermanentDeleteConnectorCommandV1, succeedPermanentDeleteConnectorCommandV1, handleClearConnectorItemsCommandV1, handleDeleteConnectorCommandV1, handlePermanentDeleteConnectorCommandV1 }
}

})